export default {
  pendingCheckProperties: "/accountPayable/pendingCheck/properties",
  pendingCheckGlAccounts: "/accountPayable/pendingCheck/glAccounts",
  // PendingCheck列表详情页
  pendingCheckShow: "/accountPayable/pendingCheck/show",
  // 新增
  pendingCheckAdd: "/accountPayable/pendingCheck/add",
  // 上传文件
  pendingCheckUpload: "/accountPayable/pendingCheck/upload",
  // 修改
  pendingCheckUpdate: "/accountPayable/pendingCheck/update",
  // 删除
  pendingCheckDelete: "/accountPayable/pendingCheck/delete",
  // Upload Pending
  pendingCheckUploadCsv: "/accountPayable/pendingCheck/uploadCsv",
  // Send to Approval
  pendingCheckApproval: "/accountPayable/pendingCheck/submitToApproval",
  // isNeedsApproval
  pendingCheckIsNeedsApproval: "/accountPayable/pendingCheck/isNeedsApproval",

  // 反显pendingCheck单个数据
  pendingCheckShowById: "/accountPayable/pendingCheck/showById",
  // 列表页面查看文件
  pendingCheckViewFile: "/accountPayable/pendingCheck/viewFile",
};
